export default __webpack_public_path__ + "static/media/otherIcon.88c4d2a1.svg";